"use client";

import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { useEffect, useState } from "react";
import { LiaCookieBiteSolid } from "react-icons/lia";

export default function CookiePopup() {
  const { showCookieConsentPopup, changeCookieConsent } = useCookieConsent();
  const [showFlag, setShowFlag] = useState<string>("hidden");

  useEffect(() => {
    if (showFlag === "hidden" && showCookieConsentPopup) {
      setShowFlag("appearing");

      setTimeout(() => {
        setShowFlag("showFlag");
      }, 300);
    } else if (showFlag === "showFlag" && !showCookieConsentPopup) {
      setShowFlag("disappearing");

      setTimeout(() => {
        setShowFlag("hidden");
      }, 300);
    }
  }, [showCookieConsentPopup]);

  return (
    (showCookieConsentPopup || showFlag !== "hidden") && (
      <div
        className={`z-1000 fixed left-0 right-0 bottom-0 flex justify-center bg-secondary transition-all ${
          showFlag === "appearing" || showFlag === "showFlag"
            ? "opacity-100 visible"
            : "opacity-0 invisible"
        }`}
      >
        <div className="px-4 py-6 max-w-5xl">
          <p className="heading-3 mb-6 flex">
            <LiaCookieBiteSolid
              size={42}
              className="text-salmon -mt-1 -ml-1 mr-4"
            />
            <span>Az oldal sütiket használ</span>
          </p>
          <p className="mb-6 text-justify">
            Ez a weboldal cookie-kat és egyéb nyomkövetési technológiákat
            használ a böngészési élmény javítása érdekében a következő célokra:
            a webhely alapvető funkcióinak engedélyezése, hogy jobb élményt
            nyújtsunk a weboldalon, weboldalunk iránti érdeklődésének mérése,
            valamint Facebook oldalunk megjelenítése a főoldalon.
          </p>
          <div className="flex justify-around gap-4 lg:justify-start">
            <button
              className="button"
              onClick={() => changeCookieConsent(true)}
            >
              Elfogadom
            </button>
            <button
              className="button-outlined px-4 text-black"
              onClick={() => changeCookieConsent(false)}
            >
              Elutasítom
            </button>
          </div>
        </div>
      </div>
    )
  );
}
